module.exports = __webpack_public_path__ + "static/media/photo-14.43098f74.avif";